import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Copyright = () => (
  <div className="Footer-Copyright">
    <Row>
      <Col md={6}>
        <p className="Footer-Copyright__Text">
          &copy; {new Date().getFullYear()} Geeks Sydney Pty Ltd. ABN: 59616635664
        </p>
      </Col>
      <Col md={6}>
        <ul className="Footer-Copyright__Nav">
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/privacy">Privacy</Link>
          </li>
          <li>
            <Link to="/terms">Terms</Link>
          </li>
        </ul>
      </Col>
    </Row>
  </div>
);

export default Copyright;